module.exports = __webpack_public_path__ + "img/TORBA4.891ec37a.jpg";